import { render } from "./SmallDefaultButton.vue?vue&type=template&id=41c6966e&scoped=true"
import script from "./SmallDefaultButton.vue?vue&type=script&lang=js"
export * from "./SmallDefaultButton.vue?vue&type=script&lang=js"

import "./SmallDefaultButton.vue?vue&type=style&index=0&id=41c6966e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c6966e"],['__file',"src/components/button/SmallDefaultButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41c6966e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41c6966e', __exports__)) {
    console.log('reload')
    api.reload('41c6966e', __exports__)
  }
  
  module.hot.accept("./SmallDefaultButton.vue?vue&type=template&id=41c6966e&scoped=true", () => {
    console.log('re-render')
    api.rerender('41c6966e', render)
  })

}


export default __exports__